import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import OpenInterest from "./openInterest";
export default combineReducers({
    reducersData: OpenInterest,
    commonData: commonReducer,
});
